import { Container, Typography, Button } from "@mui/material";
import { m } from "framer-motion";
import { styled } from '@mui/material/styles';
import { Component, ErrorInfo, ReactNode } from "react";
import Page from "./components/Page";
import { varBounce } from "./components/animate";
import Logo, { LogoProps } from "./components/Logo";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}


const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Page title="Error">
          <Container>
            <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
              <m.div variants={varBounce().in}>
                <Typography variant="h3" paragraph>
                  Sorry, there was an error
                </Typography>
              </m.div>

              <m.div variants={varBounce().in}>
                <Typography sx={{ color: 'text.secondary' }}>
                  Sorry, there was an error in the current page
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  try to refresh or contact your IT manager.
                </Typography>
              </m.div>

              <m.div style={{ marginTop: 14 }} variants={varBounce().in}>
                <Logo color={LogoProps.MAIN} />
              </m.div>

            </ContentStyle>
          </Container>
        </Page>
      )
    }

    return this.props.children;
  }
}

export default ErrorBoundary;